<script>
import { mapState } from 'vuex'
import Loader from '@/components/Loader.vue'
import Footer from '@/components/Footer.vue'
export default {
  name: 'App',
  components: {
    Loader,
    Footer,
  },
  async created() {
    await this.$store.dispatch('GET_PLANS')
    await this.$store.dispatch('GET_COUPONS')
  },
  computed: {
    ...mapState(['selectedPractice', 'onSubdomain']),
    practiceName() {
      if(this.selectedPractice) {
        return this.selectedPractice.name
      }
      return ''
    },
  },
  methods: {
    gotoSelectPractice() {
      if(!this.onSubdomain) {
        this.$router.push({ name: 'PracticeSelection' })
      }
      else {
        this.$router.push({ name: 'Home' })
      }
    }
  }
}
</script>

<template>
  <v-app fill-height id="app">
    <Loader />
    <v-container fluid id="header" class="header align-start text-center ma-0 pa-0">
      <v-row justify="center" align="center">
        <v-col md="6" cols="12">
          <img class="logo" height="75" :src="this.selectedPractice.logo" @click="gotoSelectPractice" v-if="selectedPractice" />
        </v-col>
        <v-col md="6" cols="12" class="nav">
          <div v-if="$router.currentRoute.name != 'PracticeSelection'">
            <router-link :to="{ path: '/home/memberships'}">Plans</router-link>
            <router-link :to="{ path: '/home/benefits'}">Benefits</router-link>
            <router-link :to="{ path: '/home/faqs'}">FAQs</router-link>
          </div>
        </v-col>
      </v-row>
    </v-container>
      <v-content>
        <v-container fill-height fluid class="main align-start text-center ma-auto pa-0">
          <transition name="page" mode="out-in">
            <router-view />
          </transition>
        </v-container>
      </v-content>
    <Footer />
  </v-app>
</template>

<style lang="scss" scoped>

.header {
  z-index: 10;
  border-bottom: solid 1px #eeefef;
}
.nav a{
  text-transform:  uppercase;
  margin: 0 20px;
  font-size: 16px;
  font-weight: 600;
  color: $hpp-blue;
  white-space: nowrap;
  text-decoration: none;
  display: inline-block;
}
.main {
  min-height: 800px;
}
.logo {
  cursor: pointer;
  max-width: 100%;
  height: auto;
  max-height: 75px;
}
.page-enter-active, .page-leave-active {
  transition: opacity .5s, transform .5s cubic-bezier(0,0,.58,1);
}
.page-enter {
  opacity: 0;
  transform: scale(1.05);
  transform-origin: center;
}
.page-leave-to {
  opacity: 0;
  transform: scale(.9);
  transform-origin: center;
}
.home.page-enter {
  opacity: 0;
  transform: scale(1);
  transform-origin: center;
}
.home.page-leave-to {
  opacity: 0;
  transform: scale(1);
  transform-origin: center;
}
.dev {
  font-size: 11px;
  color: grey;
}
</style>
